import { render, staticRenderFns } from "./QuestionsAndAnswers.vue?vue&type=template&id=d033275e&scoped=true&"
import script from "./QuestionsAndAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionsAndAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsAndAnswers.vue?vue&type=style&index=0&id=d033275e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d033275e",
  null
  
)

export default component.exports